<template>
  <div class="min-h-screen flex flex-col items-center justify-between py-12 px-4 sm:px-6 lg:px-8">
    <div class="w-full"></div> <!-- Spacer for top -->
    <div class="max-w-md w-full space-y-8">
      <div class="text-center">
        <img class="mx-auto h-32 w-auto" src="@/assets/logo.png" alt="Castive Logo">
        <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">
          Sign in to your account
        </h2>
      </div>
      <div class="bg-white p-8 shadow-xl rounded-2xl">
        <form class="space-y-6" @submit.prevent="login">
          <input type="hidden" name="remember" value="true">
          <div class="rounded-md shadow-sm -space-y-px">
            <div>
              <label for="email-address" class="sr-only">Email address</label>
              <input id="email-address" name="email" type="email" v-model="email" autocomplete="email" required
                class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-brand-purple focus:border-brand-purple focus:z-10 sm:text-sm"
                placeholder="Email address">
            </div>
            <div>
              <label for="password" class="sr-only">Password</label>
              <input id="password" name="password" type="password" v-model="password" autocomplete="current-password"
                required
                class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-brand-purple focus:border-brand-purple focus:z-10 sm:text-sm"
                placeholder="Password">
            </div>
          </div>

          <div class="flex items-center justify-end">
            <div class="text-sm">
              <!-- START: CORRECTED LINK COLOUR -->
              <a href="#" @click.prevent="handlePasswordReset" class="font-medium text-brand-pink-static hover:opacity-80">
                Forgot your password?
              </a>
              <!-- END: CORRECTED LINK COLOUR -->
            </div>
          </div>
          
          <div v-if="feedbackMessage" class="p-4 rounded-md text-sm" :class="isError ? 'bg-red-100 text-red-800' : 'bg-green-100 text-green-800'">
            {{ feedbackMessage }}
          </div>

          <div>
            <button type="submit" :disabled="isProcessing"
              class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-brand-orange hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-purple disabled:opacity-50">
              <span v-if="isProcessing">Signing in...</span>
              <span v-else>Sign in</span>
            </button>
          </div>
        </form>
      </div>
    </div>
    
    <footer class="py-4">
       <div class="flex items-center justify-center space-x-2">
          <img src="@/assets/logo.png" alt="Castive Logo" class="h-6 w-auto opacity-75">
          <p class="text-sm text-gray-600 font-medium">Powered by Castive</p>
       </div>
    </footer>
  </div>
</template>

<script>
import { auth } from '@/firebase';
import { signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';

export default {
  name: 'LoginView',
  data() {
    return {
      email: '', password: '',
      feedbackMessage: '', isError: false, isProcessing: false,
    }
  },
  methods: {
    async login() {
      this.feedbackMessage = ''; this.isError = false; this.isProcessing = true;
      try {
        const userCredential = await signInWithEmailAndPassword(auth, this.email, this.password);
        const idTokenResult = await userCredential.user.getIdTokenResult(true);
        if (idTokenResult.claims.role === 'super-admin') {
          this.$router.push('/super-admin');
        } else {
          // --- START: DEFINITIVE FIX FOR LOGIN REDIRECT ---
          this.$router.push('/dashboard');
          // --- END: DEFINITIVE FIX FOR LOGIN REDIRECT ---
        }
      } catch (error) {
        this.isError = true;
        switch (error.code) {
          case 'auth/invalid-email':
            this.feedbackMessage = 'Invalid email address format.';
            break;
          case 'auth/user-not-found':
          case 'auth/wrong-password':
          case 'auth/invalid-credential':
            this.feedbackMessage = 'Invalid email or password.';
            break;
          default:
            this.feedbackMessage = 'An unexpected error occurred. Please try again.';
            break;
        }
      } finally {
        this.isProcessing = false;
      }
    },
    async handlePasswordReset() {
      this.feedbackMessage = ''; this.isError = false;
      if (!this.email) {
        this.isError = true;
        this.feedbackMessage = 'Please enter your email address to reset your password.';
        return;
      }
      try {
        await sendPasswordResetEmail(auth, this.email);
        this.feedbackMessage = `Password reset link sent to ${this.email}. Please check your inbox.`;
      } catch (error) {
        this.isError = true;
        this.feedbackMessage = error.message;
        console.error('Error sending password reset email:', error);
      }
    }
  }
}
</script>